import { RetailerFooter } from "@faire/deprecated-retailer-visitor-shared/components/Footer/RetailerFooter";
import { PageInitialized } from "@faire/deprecated-retailer-visitor-shared/events";
import { useMaybeAssignCategoryTreeExperiment } from "@faire/deprecated-retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { useRecordMilestoneOnce } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useMilestone";
import { useIsCategoryPageLoading } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageLoading";
import { LoggedInCategoryPageContent } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/LoggedInCategoryPageContent";
import { useCategoryPageActionName } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useCategoryPageActionName";
import { useLoggedInCategoryPageUPLT } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useLoggedInCategoryPageUPLT";
import { useRecordCategoryPageImpression } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useRecordCategoryPageImpression";
import { useCurrentCategoryModel } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { Z_INDICES } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPageStyles";
import { trackRetailersPageViewView } from "@faire/web-api--source/events/retailers/view/pageView";
import { IRecordCategoryNodesVisibilityRequest } from "@faire/web-api--source/indigofair/category/IRecordCategoryNodesVisibilityRequest";
import { HAS_VISITED_CATEGORY_SEARCH_PAGES } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_VISITED_CATEGORY_SEARCH_PAGES";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { Column, Row } from "@faire/web/slate/Layout";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import * as React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

import Source = IRecordCategoryNodesVisibilityRequest.Source;

export const LoggedInCategoryPageBase: React.FC = () => {
  const isLoading = useIsCategoryPageLoading();
  const recordMilestoneOnce = useRecordMilestoneOnce();
  const categoryModel = useCurrentCategoryModel();
  const viewport = useViewport();

  const loadTimingRef = useLoggedInCategoryPageUPLT();
  const maybeAssignCategoryTreeExperiment =
    useMaybeAssignCategoryTreeExperiment();

  useRecordCategoryPageImpression();

  useEffect(() => {
    recordMilestoneOnce(HAS_VISITED_CATEGORY_SEARCH_PAGES);
  }, [recordMilestoneOnce]);

  useEffect(() => {
    maybeAssignCategoryTreeExperiment(
      () => [categoryModel.mostSpecificPathIdentifier],
      viewport.isMobile
        ? Source.WEB_MOBILE_BREADCRUMB
        : Source.WEB_DESKTOP_BREADCRUMB
    );
  }, [
    viewport.isMobile,
    categoryModel.mostSpecificPathIdentifier,
    maybeAssignCategoryTreeExperiment,
  ]);

  useEffect(() => {
    if (!isLoading) {
      PageInitialized.publish();
    }
  }, [isLoading]);

  const { pathname } = useLocation();
  const pageType = pathname.includes("/suppliers") ? "suppliers" : "category";
  const pageName = useCategoryPageActionName();
  const [c1, c2, c3] = categoryModel.urlIdStrings;

  useEffect(() => {
    trackRetailersPageViewView(
      "",
      "",
      "",
      pageType,
      pathname,
      pageName,
      c1 ?? "",
      c2 ?? "",
      c3 ?? ""
    );
  }, [pageType, pathname, pageName, c1, c2, c3]);

  return (
    <RootContainer>
      <StyledMainContent pageLoadTimingRef={loadTimingRef} />
      <WhenVisibilityIsImminent
        customizePlaceholder={<RetailerFooterPlaceholder />}
      >
        <BlockInheritRow>
          <StyledRetailerFooter hideReferral />
        </BlockInheritRow>
      </WhenVisibilityIsImminent>
    </RootContainer>
  );
};

const StyledMainContent = styled(LoggedInCategoryPageContent)`
  ${responsiveMediaQueries.desktopAndAbove} {
    padding: 0px;
  }
`;

// eslint-disable-next-line @faire/prefer-slate-attrs -- display: block is incompatible with Flex
const BlockInheritRow = styled(Row).attrs({ align: "flex-start" })`
  &&& {
    display: block;
  }
  position: inherit;
  width: 100%;
`;

const StyledRetailerFooter = styled(RetailerFooter)`
  ${responsiveMediaQueries.desktopAndAbove} {
    background-color: white;
    position: relative;
    z-index: ${Z_INDICES.footer.desktopAndAbove};
  }
`;

const RetailerFooterPlaceholder = styled.div`
  ${responsiveMediaQueries.tabletAndBelow} {
    height: 750px;
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    height: 431px;
  }
`;

const RootContainer = styled(Column)`
  width: 100%;
`;
